import { EMPTY_ARRAY } from '@applyonline/shared';
import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'merchants';
const SEARCH = 'search';
const DETAIL = 'detail';
const PROMO = 'promo';
const keysFactory = {
    all: (financingProgram) => [{ scope: SCOPE, financingProgram }],
    search: (filters, financingProgram) => [{ scope: SCOPE, entity: SEARCH, financingProgram }, filters],
    allDetails: (financingProgram) => [{ scope: SCOPE, entity: DETAIL, financingProgram }],
    detail: (id, financingProgram) => [{ scope: SCOPE, entity: DETAIL, id, financingProgram }],
    paymentPlan: (merchantId, merchantPaymentPlanId, financingProgram) => [{ scope: SCOPE, entity: DETAIL, merchantId, merchantPaymentPlanId, financingProgram }],
    promo: (dto, financingProgram) => [{ scope: PROMO, financingProgram }, dto],
};
const searchMerchantsByName = (financingProgram) => async ({ queryKey: [{ financingProgram: _financingProgram }, filters], }) => {
    const response = await apiClient.post(`${financingProgram}/merchant/search`, filters);
    return response.data;
};
export function useSearchMerchant(filters, financingProgram) {
    const enabled = !!filters.nameContains && filters.nameContains.length > 3;
    const { isFetching, data } = useQuery({
        queryKey: [...keysFactory.search(filters, financingProgram)],
        queryFn: searchMerchantsByName(financingProgram),
        enabled,
    });
    const ret = enabled && data ? data : EMPTY_ARRAY;
    return [ret, isFetching];
}
const getMerchant = (financingProgram) => async ({ queryKey: [{ id }], }) => {
    const parts = id.split('*');
    const merchantId = parts.length === 1 ? id : parts[1];
    const response = await apiClient.get(`${financingProgram}/merchant/${encodeURIComponent(merchantId)}`);
    return response.data;
};
export function useMerchantById(merchantId, financingProgram) {
    const { isFetching, data, error } = useQuery({
        queryKey: keysFactory.detail(merchantId, financingProgram),
        queryFn: getMerchant(financingProgram),
        enabled: !!merchantId,
    });
    return [data ?? null, isFetching, error];
}
const validatePromoCode = (financingProgram) => async (dto) => {
    const response = await apiClient.post(`${financingProgram}/merchant/validatePromotionCode`, dto);
    return response.data;
};
export function useValidatePromoCode(financingProgram) {
    const { mutateAsync, isPending, reset } = useMutation({
        mutationFn: validatePromoCode(financingProgram),
    });
    return [mutateAsync, isPending, reset];
}
const getMerchantPaymentPlan = (financingProgram) => async ({ queryKey: [{ merchantId, merchantPaymentPlanId }], }) => {
    const parts = merchantId.split('*');
    const formattedMerchantId = parts.length === 1 ? merchantId : parts[1];
    const response = await apiClient.get(`${financingProgram}/merchant/${encodeURIComponent(formattedMerchantId)}/PaymentPlans/${merchantPaymentPlanId}`);
    return response.data;
};
export function useMerchantPaymentPlanById(merchantId, merchantPaymentPlanId, financingProgram) {
    const { isFetching, data, error } = useQuery({
        queryKey: keysFactory.paymentPlan(merchantId, merchantPaymentPlanId, financingProgram),
        queryFn: getMerchantPaymentPlan(financingProgram),
        enabled: Boolean(merchantId) && Boolean(merchantPaymentPlanId),
    });
    return [data ?? null, isFetching, error];
}
